import { useCallback } from 'react';
import { useLazyGetCustomersQuery } from 'services';
import { FindAllOmniCustomersDto } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useLazyOmniCustomers() {
  const [trigger, { data: dataResponse, isLoading, isFetching, originalArgs }] = useLazyGetCustomersQuery();

  const { rows, count } = dataResponse?.data || {};
  const hasMore = Boolean(rows && count && rows.length < count);

  const handleLoadMore = useCallback(() => {
    if (hasMore)
      trigger({
        ...originalArgs,
        limit: pageSize,
        skip: rows?.length
      });
  }, [hasMore, originalArgs, rows]);

  const fetchData = useCallback((value?: Partial<FindAllOmniCustomersDto>) => {
    trigger({
      skip: 0,
      limit: pageSize,
      ...originalArgs,
      ...value
    });
  }, []);

  return {
    data: rows || [],
    count: count || 0,
    isLoading: isLoading,
    hasMore,
    fetchData,
    handleLoadMore,
    isFetching: isFetching,
    originalArgs
  };
}
